import { LitElement, html } from "lit";

import { customElement, property, state } from "lit/decorators.js";

import "ui-components/confirmation/wow-confirmation";

import { styles } from "./confirmation-edit-draft-discard.css";

import { translate } from "../../translations/i18n";

@customElement("confirmation-edit-draft-discard")
export class ConfirmationEditDraftDiscard extends LitElement {
  static override styles = styles;

  @state()
  private isSubmitting = false;

  @property({ type: String })
  public header = translate("confirmation.header");

  @property({ type: String })
  public continueEditing = translate("confirmation.continueEditing");

  @property({ type: String })
  public saving = translate("confirmation.saving");

  @property({ type: String })
  public saveAsDraft = translate("confirmation.saveAsDraft");

  @property({ type: String })
  private discardChanges = translate("confirmation.discardChanges");

  private handleContinueEditing() {
    this.dispatchEvent(
      new CustomEvent("continue-editing", {
        bubbles: true,
        composed: true,
      }),
    );
  }
  private handleConfirmationClose() {
    this.dispatchEvent(
      new CustomEvent("confirmation-close", {
        bubbles: true,
        composed: true,
      }),
    );
  }
  private handleSaveAsDraft() {
    this.dispatchEvent(
      new CustomEvent("save-as-draft", {
        bubbles: true,
        composed: true,
      }),
    );
  }
  private handleDiscardChanges() {
    this.dispatchEvent(
      new CustomEvent("discard-changes", {
        bubbles: true,
        composed: true,
      }),
    );
  }

  protected override render() {
    return html`
      <wow-confirmation header="${this.header}" @close=${this.handleConfirmationClose}>
        <div class="confirmation-buttons">
          <wow-button variant="neutral" @click=${this.handleContinueEditing}> ${this.continueEditing} </wow-button>
          <wow-button variant="neutral" ?disabled=${this.isSubmitting} @click=${this.handleSaveAsDraft}>
            ${this.isSubmitting ? this.saving : this.saveAsDraft}
          </wow-button>
          <wow-button variant="danger" @click=${this.handleDiscardChanges}> ${this.discardChanges} </wow-button>
        </div>
      </wow-confirmation>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "confirmation-edit-draft-discard": ConfirmationEditDraftDiscard;
  }
}
